module.exports = __webpack_public_path__ + "static/media/logo.e0edc9b0.svg";